var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1520,
    height: 638,
    viewBox: "0 0 1520 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_638_5450",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1520,
    height: 638
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1520,
    height: 638,
    rx: 10,
    fill: "#1C1C1C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_638_5450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.874 547.425C512.874 547.425 324.953 410.254 71.9127 411.359C-181.148 412.456 215.572 856.151 215.572 856.151C215.564 856.136 193.571 831.092 193.571 831.092",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.541 537.338C502.541 537.338 315.993 395.635 62.7242 398.442C-190.534 401.248 201.589 861.045 201.589 861.045C201.581 861.03 179.847 835.075 179.847 835.075",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.932 526.942C491.932 526.942 306.739 380.69 53.2506 385.206C-200.235 389.725 187.329 865.608 187.329 865.608C187.321 865.592 165.846 838.726 165.846 838.726",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.92 516.086C480.92 516.086 297.068 365.283 43.3469 371.508C-210.38 377.735 172.654 869.71 172.654 869.71C172.645 869.694 151.427 841.917 151.427 841.917",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.861 505.175C469.861 505.175 287.345 349.835 33.3774 357.765C-220.589 365.697 157.927 873.773 157.927 873.773C157.918 873.758 136.955 845.069 136.955 845.069",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.74 494.215C458.74 494.215 277.54 334.32 23.3108 343.955C-230.926 353.595 143.116 877.776 143.116 877.776C143.108 877.76 122.398 848.159 122.398 848.159",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.586 483.196C447.586 483.196 267.691 318.742 13.1679 330.087C-241.355 341.433 128.243 881.728 128.243 881.728C128.234 881.712 107.776 851.199 107.776 851.199",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.391 472.136C436.391 472.136 257.788 303.12 2.9789 316.183C-251.828 329.23 113.336 885.654 113.336 885.654C113.327 885.637 93.1187 854.21 93.1187 854.21",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.423 309.42C145.423 309.42 453.965 395.522 538.952 598.781C623.937 802.025 -301.6 692.668 -301.6 692.668L-249.468 698.521",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.049 299.988C131.049 299.988 434.271 388.052 521.089 590.379C607.911 792.704 -298.939 676.252 -298.939 676.252L-247.865 682.507",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.536 288.934C116.536 288.934 414.435 378.957 503.078 580.349C591.724 781.74 -296.414 658.214 -296.414 658.214L-246.4 664.87",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.883 277.77C101.883 277.77 394.458 369.747 484.925 570.217C575.397 770.687 -294.034 640.085 -294.034 640.085L-245.079 647.142",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1098 266.492C87.1098 266.492 374.349 360.405 466.635 559.952C558.918 759.484 -291.796 621.832 -291.796 621.832L-243.901 629.288",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2081 255.163C72.2081 255.163 354.117 351.023 448.207 549.631C542.3 748.239 -289.703 603.533 -289.703 603.533L-242.867 611.389",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7317 244.153C56.7317 244.153 333.308 341.954 429.193 539.623C525.081 737.291 -288.22 585.558 -288.22 585.558L-242.444 593.812",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0364 233.183C41.0364 233.183 312.277 332.922 409.948 529.65C507.63 726.39 -286.948 567.642 -286.948 567.642L-242.232 576.295",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.398 222.894C24.398 222.894 290.292 324.553 389.755 520.366C489.214 716.164 -286.638 550.412 -286.638 550.412L-242.983 559.461",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02618 213.114C7.02618 213.114 267.577 316.702 368.808 511.571C470.041 706.438 -287.09 533.683 -287.09 533.683L-244.494 543.129",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.0325 203.814C-11.0325 203.814 244.172 309.326 347.159 503.249C450.149 697.171 -288.25 517.44 -288.25 517.44L-246.715 527.282",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.7087 194.973C-29.7087 194.973 220.145 302.405 324.877 495.381C429.618 688.37 -290.069 501.667 -290.069 501.667L-249.593 511.902",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.4655 186.66C-48.4655 186.66 196.026 295.993 302.503 488.048C408.977 680.088 -291.962 486.451 -291.962 486.451L-252.547 497.082",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.2254 178.823C-67.2254 178.823 171.905 290.065 280.101 481.17C388.299 672.274 -293.902 471.69 -293.902 471.69L-255.548 482.712",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.6888 171.702C-84.6888 171.702 149.074 284.849 258.975 475.002C368.876 665.154 -294.576 457.651 -294.576 457.651L-257.283 469.067",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.027 165.226C-101.027 165.226 127.358 280.259 238.954 469.472C350.549 658.684 -294.171 444.27 -294.171 444.27L-257.941 456.076",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.305 159.322C-116.305 159.322 106.701 276.249 219.965 464.507C333.229 652.764 -292.73 431.463 -292.73 431.463L-257.561 443.66",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-130.607 153.938C-130.607 153.938 87.0141 272.754 201.935 460.068C316.855 647.383 -290.336 419.211 -290.336 419.211C-290.345 419.214 -256.229 431.799 -256.229 431.799",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.877694
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape1);
export default __webpack_public_path__ + "static/media/bg-shape-1.69f7bc3037b0bd8bec2a19c10fe2c3dd.svg";
export { ForwardRef as ReactComponent };